import { render } from "./OrderItem.vue?vue&type=template&id=1697746e&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"

import "./OrderItem.vue?vue&type=style&index=0&id=1697746e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1697746e"

export default script